module.exports = __webpack_public_path__ + "assets/favicons/android-chrome-512x512.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/android-chrome-512x512.png
// module id = ydWG
// module chunks = 1